export default {
    equipments: [],
}